/**
 * @generated SignedSource<<5998bb761ce3e1f2597af5fa88015398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ICAMinButikStatus = "ACTIVE" | "PENDING_LOGIN";
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type IntegrationsAdminScreenQuery$variables = Record<PropertyKey, never>;
export type IntegrationsAdminScreenQuery$data = {
  readonly store: {
    readonly hasSoftOneOrgIntegration: boolean | null;
    readonly id: string;
    readonly integrationBokaklipp: {
      readonly __typename: "IntegrationBokaklipp";
    } | null;
    readonly integrationFlourish: {
      readonly __typename: "IntegrationFlourish";
      readonly id: string;
    } | null;
    readonly integrationFlyers: ReadonlyArray<{
      readonly __typename: "IntegrationEmaginFlyer";
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminFlyerListItem_IntegrationEmaginFlyer">;
    }> | null;
    readonly integrationICAMinButik: {
      readonly __typename: "ICAMinButikIntegration";
      readonly status: ICAMinButikStatus;
      readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher">;
    } | null;
    readonly integrationInvafresh: {
      readonly __typename: "IntegrationInvafresh";
    } | null;
    readonly integrationNewsfeeds: ReadonlyArray<{
      readonly __typename: "IntegrationNewsfeed";
      readonly " $fragmentSpreads": FragmentRefs<"IntegrationNewsfeedScreen_IntegrationNewsfeedListItem">;
    }>;
    readonly integrationPollFiles: ReadonlyArray<{
      readonly __typename: "IntegrationPollFile";
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminPollFileListItem_IntegrationPollFile">;
    }>;
    readonly integrationPushAppy: {
      readonly __typename: "IntegrationPushAppy";
      readonly id: string;
    } | null;
    readonly integrationQuinyx: {
      readonly __typename: "IntegrationQuinyx";
      readonly id: string;
    } | null;
    readonly integrationSoftOne: {
      readonly __typename: "IntegrationSoftOne";
      readonly id: string;
    } | null;
    readonly integrationTilTid: {
      readonly __typename: "IntegrationTilTid";
      readonly id: string;
    } | null;
    readonly integrationTomra: {
      readonly __typename: "IntegrationTomra";
    } | null;
    readonly integrationTooEasy: {
      readonly __typename: "IntegrationTooEasy";
      readonly id: string;
    } | null;
    readonly integrationTurnpike: {
      readonly __typename: "IntegrationTurnpike";
      readonly id: string;
    } | null;
    readonly integrationWebFetchers: ReadonlyArray<{
      readonly __typename: "IntegrationWebFetch";
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminWebFetcherListItem_IntegrationWebFetcher">;
    }> | null;
    readonly myRole: Roles;
    readonly serviceAccounts: ReadonlyArray<{
      readonly __typename: "ServiceAccount";
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminHRProviderListItem_Store" | "IntegrationAdminServiceAccountsListItem_Store">;
  };
};
export type IntegrationsAdminScreenQuery = {
  response: IntegrationsAdminScreenQuery$data;
  variables: IntegrationsAdminScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "myRole",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSoftOneOrgIntegration",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationPushAppy",
  "kind": "LinkedField",
  "name": "integrationPushAppy",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationTilTid",
  "kind": "LinkedField",
  "name": "integrationTilTid",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationTooEasy",
  "kind": "LinkedField",
  "name": "integrationTooEasy",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationSoftOne",
  "kind": "LinkedField",
  "name": "integrationSoftOne",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v9 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationTurnpike",
  "kind": "LinkedField",
  "name": "integrationTurnpike",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationQuinyx",
  "kind": "LinkedField",
  "name": "integrationQuinyx",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationFlourish",
  "kind": "LinkedField",
  "name": "integrationFlourish",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v13 = [
  (v3/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastError",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationsAdminScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IntegrationAdminHRProviderListItem_Store"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IntegrationAdminServiceAccountsListItem_Store"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEmaginFlyer",
            "kind": "LinkedField",
            "name": "integrationFlyers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IntegrationAdminFlyerListItem_IntegrationEmaginFlyer"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationPollFile",
            "kind": "LinkedField",
            "name": "integrationPollFiles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IntegrationAdminPollFileListItem_IntegrationPollFile"
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationTomra",
            "kind": "LinkedField",
            "name": "integrationTomra",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationInvafresh",
            "kind": "LinkedField",
            "name": "integrationInvafresh",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationBokaklipp",
            "kind": "LinkedField",
            "name": "integrationBokaklipp",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationNewsfeed",
            "kind": "LinkedField",
            "name": "integrationNewsfeeds",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IntegrationNewsfeedScreen_IntegrationNewsfeedListItem"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationWebFetch",
            "kind": "LinkedField",
            "name": "integrationWebFetchers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IntegrationAdminWebFetcherListItem_IntegrationWebFetcher"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ICAMinButikIntegration",
            "kind": "LinkedField",
            "name": "integrationICAMinButik",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher"
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceAccount",
            "kind": "LinkedField",
            "name": "serviceAccounts",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationsAdminScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceAccount",
            "kind": "LinkedField",
            "name": "serviceAccounts",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceAccountAuthToken",
                "kind": "LinkedField",
                "name": "authTokens",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "expiresAt",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEmaginFlyer",
            "kind": "LinkedField",
            "name": "integrationFlyers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eMaginId",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastCheckedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationPollFile",
            "kind": "LinkedField",
            "name": "integrationPollFiles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "file",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationTomra",
            "kind": "LinkedField",
            "name": "integrationTomra",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationInvafresh",
            "kind": "LinkedField",
            "name": "integrationInvafresh",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationBokaklipp",
            "kind": "LinkedField",
            "name": "integrationBokaklipp",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationNewsfeed",
            "kind": "LinkedField",
            "name": "integrationNewsfeeds",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "provider",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationWebFetch",
            "kind": "LinkedField",
            "name": "integrationWebFetchers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              (v16/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ICAMinButikIntegration",
            "kind": "LinkedField",
            "name": "integrationICAMinButik",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52886ce8a4604a8382d103fb53ea0f27",
    "id": null,
    "metadata": {},
    "name": "IntegrationsAdminScreenQuery",
    "operationKind": "query",
    "text": "query IntegrationsAdminScreenQuery {\n  store {\n    myRole\n    ...IntegrationAdminHRProviderListItem_Store\n    ...IntegrationAdminServiceAccountsListItem_Store\n    hasSoftOneOrgIntegration\n    id\n    integrationFlyers {\n      __typename\n      id\n      ...IntegrationAdminFlyerListItem_IntegrationEmaginFlyer\n    }\n    integrationPollFiles {\n      __typename\n      id\n      ...IntegrationAdminPollFileListItem_IntegrationPollFile\n    }\n    integrationPushAppy {\n      __typename\n      id\n    }\n    integrationTilTid {\n      __typename\n      id\n    }\n    integrationTooEasy {\n      __typename\n      id\n    }\n    integrationSoftOne {\n      __typename\n      id\n    }\n    integrationTurnpike {\n      id\n      __typename\n    }\n    integrationQuinyx {\n      id\n      __typename\n    }\n    integrationFlourish {\n      __typename\n      id\n    }\n    integrationTomra {\n      __typename\n      id\n    }\n    integrationInvafresh {\n      __typename\n      id\n    }\n    integrationBokaklipp {\n      __typename\n      id\n    }\n    integrationNewsfeeds {\n      __typename\n      ...IntegrationNewsfeedScreen_IntegrationNewsfeedListItem\n      id\n    }\n    integrationWebFetchers {\n      __typename\n      id\n      ...IntegrationAdminWebFetcherListItem_IntegrationWebFetcher\n    }\n    integrationICAMinButik {\n      __typename\n      ...IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher\n      status\n    }\n    serviceAccounts {\n      __typename\n      id\n    }\n  }\n}\n\nfragment IntegrationAdminFlyerListItem_IntegrationEmaginFlyer on IntegrationEmaginFlyer {\n  __typename\n  id\n  eMaginId\n  status\n  lastCheckedAt\n  title\n  lastError\n}\n\nfragment IntegrationAdminHRProviderListItem_Store on Store {\n  employeeScheduleTypes {\n    id\n    assignedTeams {\n      id\n    }\n  }\n}\n\nfragment IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher on ICAMinButikIntegration {\n  __typename\n  status\n}\n\nfragment IntegrationAdminPollFileListItem_IntegrationPollFile on IntegrationPollFile {\n  id\n  url\n  file {\n    name\n    id\n  }\n}\n\nfragment IntegrationAdminServiceAccountsListItem_Store on Store {\n  serviceAccounts {\n    __typename\n    authTokens {\n      expiresAt {\n        isoString\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment IntegrationAdminWebFetcherListItem_IntegrationWebFetcher on IntegrationWebFetch {\n  __typename\n  id\n  url\n  lastError\n}\n\nfragment IntegrationNewsfeedScreen_IntegrationNewsfeedListItem on IntegrationNewsfeed {\n  id\n  provider\n}\n"
  }
};
})();

(node as any).hash = "1747461ab569d35aa0a67e6d291573db";

export default node;
